<template>
  <div v-if="visible" class="push-confirm-overlay">
    <div class="push-confirm-modal">
      <div class="push-confirm-header">
        <button class="close-btn" type="button" @click="handleCancel">
          <svg-icon icon-class="close" />
        </button>
      </div>
      <div class="push-confirm-body">
        <p class="push-confirm-message">{{ messageText }}</p>
      </div>
      <div class="push-confirm-footer">
        <button type="button" class="btn-cancel" @click="handleCancel">
          {{ cancelText }}
        </button>
        <button type="button" class="btn-confirm" @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SvgIcon from '@/components/SvgIcon.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  activityName: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel']);

const { t } = useI18n();

const visible = computed(() => props.modelValue);

const messageText = computed(() => props.message || t('gameActManager.pushConfirmMessage'));
const cancelText = computed(() => t('gameActManager.cancel'));
const confirmText = computed(() => t('gameActManager.confirm'));

const handleCancel = () => {
  emit('update:modelValue', false);
  emit('cancel');
};

const handleConfirm = () => {
  emit('update:modelValue', false);
  emit('confirm');
};
</script>

<style scoped lang="less">

.push-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 99999; // 確保高於遊戲內及宿主環境所有遮罩與彈窗
}

.push-confirm-modal {
  position: absolute;
  z-index: 100000;
  top: 10vh;
  left: 50%;
  transform: translateX(-50%);
  min-width: 400px;
  max-width: 95vw;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  border: 1px solid #e0e4f0;
  overflow: hidden;
}

.push-confirm-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 6px 20px;
  background: #ffffff;
  color: #1f2933;
  margin-bottom: 20px;
}

.close-btn {
 position: absolute;
 right: 16px;
 top: 16px;
}

.close-btn :deep(svg) {
  width: 20px;
  height: 20px;
}

.push-confirm-body {
  padding: 20px 20px 8px;
}

.push-confirm-message {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #4a5568;
  font-weight: 600;
  white-space: pre-line;
}

.push-confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px 18px;
}

.btn-cancel,
.btn-confirm {
  min-width: 96px;
  height: 34px;
  padding: 0 14px;
  border-radius: 18px;
  border: none;
  font-size: 14px;
  cursor: pointer;
}

.btn-cancel {
  background: #e0e0e0;
  color: #555555;
}

.btn-cancel:hover {
  background: #d5d5d5;
}

.btn-confirm {
  background: #2f80ed;
  color: #ffffff;
}

.btn-confirm:hover {
  background: #2568c4;
}
</style>
